import { render, staticRenderFns } from "./Weather2.vue?vue&type=template&id=be20ca3a&"
import script from "./Weather2.vue?vue&type=script&lang=js&"
export * from "./Weather2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports